import React from "react"
import DfbInput from "./dfb_input"

const DfbInputTextarea = React.forwardRef((props, ref) => {
  return (
    <DfbInput
      ref={ref}
      tagName={props.tagName}
      name={props.name}
      idPrefix={props.idPrefix}
      rows={props.rows}
      disabled={props.disabled}
      label={props.label}
      error={props.error}
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      placeholder={props.placeholder}
      errorMessage={props.errorMessage}
      required={props.required}
      focused={props.focused}
    />
  )
})

DfbInputTextarea.defaultProps = {
  tagName: "textarea",
  name: "textarea",
  idPrefix: "textarea",
  rows: "4",
  required: false,
  disabled: false,
  error: false,
  focused: false,
}
export default DfbInputTextarea
